export default __webpack_public_path__ + "static/media/icon-alert-circle.23602268.svg";